var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconComms19X20 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 20.062,
    viewBox: "0 0 19 20.062",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_26387",
    "data-name": "Group 26387",
    transform: "translate(-2024 -2579.998)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mail_3_",
    "data-name": "mail (3)",
    transform: "translate(2024 2588.86)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26291",
    "data-name": "Group 26291"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46753",
    "data-name": "Path 46753",
    d: "M12.6,42.667H1.4a1.394,1.394,0,0,0-1.393,1.4L0,52.467a1.4,1.4,0,0,0,1.4,1.4H12.6a1.4,1.4,0,0,0,1.4-1.4v-8.4A1.4,1.4,0,0,0,12.6,42.667Zm0,2.8L7,48.967l-5.6-3.5v-1.4l5.6,3.5,5.6-3.5Z",
    transform: "translate(0 -42.667)",
    fill: "#999"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_15",
    "data-name": "Subtraction 15",
    d: "M13,10H1A1,1,0,0,1,0,9V3A1,1,0,0,1,1,2h.667L3,0,4.333,2H13a1,1,0,0,1,1,1V9A1,1,0,0,1,13,10ZM10,5a1,1,0,1,0,1,1A1,1,0,0,0,10,5ZM7,5A.989.989,0,0,0,6,6,1,1,0,1,0,7,5ZM4,5A1,1,0,1,0,5,6,1,1,0,0,0,4,5Z",
    transform: "rotate(180 1021.5 1294.999)",
    fill: "#999"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconComms19X20);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_comms19x20.e16f0109d8ae514ffcb93962fe6ec802.svg";